module.exports = __webpack_public_path__ + "img/profchecksign.49b8b4cf.png";